export const yesNoList = [
  { key: 'Y', value: 'Yes' },
  { key: 'N', value: 'No' },
];
